import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchFilterModule} from '../search-filter/search-filter.module';
import {CollectionsRoutingModule} from './collections-routing.module';
import {CollectionsComponent} from './components/collections/collections.component';
import {CollectionsFilterComponent} from './components/collections-filter/collections-filter.component';
import {CollectionDetailComponent} from './components/collection-detail/collection-detail.component';
import {ProductsGridComponent} from './components/products-grid/products-grid.component';
import {CollectionsListComponent} from './components/collections-list/collections-list.component';
import {HighlightCollectionComponent} from './components/highlight-collection/highlight-collection.component';
import {I18NextModule} from 'angular-i18next';
import {CoreModule} from '../../core/core.module';


@NgModule({
  declarations: [
    CollectionsComponent,
    CollectionsFilterComponent,
    CollectionDetailComponent,
    ProductsGridComponent,
    CollectionsListComponent,
    HighlightCollectionComponent
  ],
  exports: [
    CollectionsListComponent,
    HighlightCollectionComponent,
    CollectionsFilterComponent
  ],
  imports: [
    CommonModule,
    CollectionsRoutingModule,
    CoreModule,
    SearchFilterModule,
    I18NextModule,
    CoreModule,
  ]
})
export class CollectionsModule {
}
